/**
 * Détection du préfixe locale dans l’URL — sans import i18n (évite cycle i18n ↔ localeRoutes).
 */

export type PathPrefixedLocale = 'en' | 'es' | 'de' | 'it' | 'nl-NL';

const PREFIXED_LOCALES: { prefix: string; locale: PathPrefixedLocale }[] = [
  { prefix: '/en', locale: 'en' },
  { prefix: '/es', locale: 'es' },
  { prefix: '/de', locale: 'de' },
  { prefix: '/it', locale: 'it' },
];

export function isLocaleRoutesNlNlEnabled(): boolean {
  return (
    process.env.REACT_APP_LOCALE_ROUTES_NL_NL === 'true' ||
    process.env.VITE_LOCALE_ROUTES_NL_NL === 'true' ||
    // Aligné ES/EN/DE/IT : actif en local pour tester /nl ; prod = opt-in explicite.
    process.env.NODE_ENV === 'development'
  );
}

export function getLocaleFromPath(pathname: string): PathPrefixedLocale | null {
  if (isLocaleRoutesNlNlEnabled() && (pathname === '/nl' || pathname.startsWith('/nl/'))) {
    return 'nl-NL';
  }
  for (const { prefix, locale } of PREFIXED_LOCALES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return locale;
  }
  return null;
}

export function stripPathLocalePrefix(pathname: string): string {
  if (pathname === '/nl' || pathname.startsWith('/nl/')) {
    if (pathname === '/nl') return '/';
    return pathname.slice('/nl'.length) || '/';
  }
  for (const { prefix } of PREFIXED_LOCALES) {
    if (pathname === prefix) return '/';
    if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length) || '/';
  }
  return pathname;
}
